function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ticket-approval-icon_svg__clip0_9361_58184)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.31.734h7.19a.75.75 0 01.75.75v12a.75.75 0 01-.75.75H3a.75.75 0 01-.75-.75v-9.69c0-.198.08-.39.22-.53L4.78.954a.75.75 0 01.53-.22z",
  fill: "#FAEFDE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.25 14.25l-.037-2.366 10.872-10.87.165 5.735-7.5 7.5h-3.5zm-.037-4.963L10.765.734l1.438.063-9.953 9.952-.037-1.462zm0-1.5L9.25.749H10L2.213 8.537v-.75z",
  fill: "#FFF7F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.875 2.75l.31.565.565.31-.565.31-.31.565-.31-.565-.565-.31.565-.31.31-.565zm-3.77-.5l.212.39.393.215-.393.212-.212.393-.215-.393-.39-.212.39-.215.215-.39zM3.662 10l.146.265.267.147-.268.145-.144.268-.148-.268-.265-.145.265-.147.147-.265z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.25.75v3h-3l3-3z",
  fill: "#BBDEF9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.25 9.75a3 3 0 100 6 3 3 0 000-6z",
  fill: "#72CAAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.25 12.5a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5a.25.25 0 00-.25-.25zm1.25 0a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5a.25.25 0 00-.25-.25zm1.25 0a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5a.25.25 0 00-.25-.25zm1.25 0a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5A.25.25 0 007 12.5zm1.25 0a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5a.25.25 0 00-.25-.25zm2-7h-1a.25.25 0 000 .5h1a.25.25 0 000-.5zm-6 .5h4a.25.25 0 000-.5h-4a.25.25 0 000 .5zm0 1h5a.25.25 0 000-.5h-5a.25.25 0 000 .5zM8.5 9H4.25a.25.25 0 000 .5H8.5a.25.25 0 000-.5zm1.25-1h-5.5a.25.25 0 000 .5h5.5a.25.25 0 000-.5z",
  fill: "#8D6C9F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.572 11.573l-1.822 1.825-.823-.822a.25.25 0 00-.352.352l1 1a.25.25 0 00.352 0l2-2a.25.25 0 00-.352-.352l-.003-.003z",
  fill: "#F9EFDE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.25 12.5a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5a.25.25 0 00-.25-.25zm1.25 0a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5a.25.25 0 00-.25-.25zm1.25 0a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5a.25.25 0 00-.25-.25zm1.25 0a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5A.25.25 0 007 12.5zm1.25 0a.25.25 0 00-.25.25v.5a.25.25 0 00.5 0v-.5a.25.25 0 00-.25-.25z",
  fill: "#8D6C9F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 9.75v-8.5a.75.75 0 00-.75-.75H5.415a1.25 1.25 0 00-.885.365L2.365 3.03A1.25 1.25 0 002 3.915v9.835a.75.75 0 00.75.75h6.765A3.25 3.25 0 1013.5 9.75zM4.885 1.22A.75.75 0 015 1.125V3.25a.25.25 0 01-.25.25H2.625a.75.75 0 01.095-.115L4.885 1.22zM2.75 14a.25.25 0 01-.25-.25V4h2.25a.75.75 0 00.75-.75V1h7.25a.25.25 0 01.25.25v8.34A3.25 3.25 0 009.25 14h-6.5zm9.5 1.5a2.75 2.75 0 110-5.5 2.75 2.75 0 010 5.5z",
  fill: "#8D6C9F"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ticket-approval-icon_svg__clip0_9361_58184"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgTicketApprovalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgTicketApprovalIcon;